export const mainPadding = "p-6 md:px-10 md:py-8";

export const hScreenWithoutHeader = "min-h-[calc(100vh-64px)]";

/** ヘッダーを除いたビューポート固定高さ（独立スクロール用） */
export const hFixedWithoutHeader = "h-[calc(100vh-64px)]";

export const hScreenWithoutHeaderAndPadding =
  "min-h-[calc(100vh-64px-3rem)] md:min-h-[calc(100vh-64px-5rem)]";

export const sidebarWidth = "w-[230px] min-w-[230px]";
